<div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px" class="detail-subheader">
  <strong fxFlex>{{ label }}</strong>

  <sbnb-button *ngIf="!editMode" size="mini" label="Edit" type="text" (click)="editMode = true"></sbnb-button>

  <sbnb-property-update-status [edited]="edited" [hasAirbnbListing]="hasAirbnbListing"></sbnb-property-update-status>
</div>
<div fxLayout="row wrap" fxLayoutGap="8px" *ngIf="!editMode">
  <span class="night text__small" *ngIf="!amenities || amenities?.length === 0">Unknown</span>

  <span class="amenity-badge" *ngFor="let amenity of amenities">
    {{ amenity | amenityLabel: flattenedAmenities }}
  </span>
</div>

<!-- Edit mode -->
<div [hidden]="!editMode">
  <div class="amenity-scroller">
    <input
      type="search"
      class="search-input"
      placeholder="Search amenities..."
      [(ngModel)]="searchCriteria"
      style="position: sticky; top: 0px; background: #fff; z-index: 9" />
    <mat-selection-list dense #amenityList>
      <ng-container *ngFor="let group of availableAmenities">
        <div *ngIf="!searchCriteria" class="group-header">
          <div mat-subheader>
            {{ group.title }}
            <span *ngIf="group.description">&nbsp;- {{ group.description }}</span>
          </div>
        </div>

        <ng-container *ngFor="let amenity of group.amenities">
          <mat-list-option
            *ngIf="amenity.label.toLowerCase().indexOf(searchCriteria.toLowerCase()) > -1 || !searchCriteria"
            [selected]="amenities?.indexOf(amenity.key) > -1"
            [value]="amenity.key">
            <div mat-line>{{ amenity.label }}</div>
            <div *ngIf="amenity.description" class="amenity-description">
              {{ amenity.description }}
            </div>
          </mat-list-option>
        </ng-container>
      </ng-container>
    </mat-selection-list>
  </div>

  <div fxLayoutAlign="end center" fxLayoutGap="8px" style="margin-top: 12px">
    <sbnb-button label="Cancel" type="secondary" size="mini" (clicked)="editMode = false"></sbnb-button>
    <sbnb-button label="Save" size="mini" (clicked)="setAmenities(amenityList.selectedOptions)"></sbnb-button>
  </div>
</div>
